<div
  class="box-timer seds-timer"
  role="timer"
  aria-label="Contador regressivo para a sessão"
  tabindex="0"
  aria-valuemax="60"
  aria-valuemin="0"
  aria-describedby="Lembrete visual do tempo restante.">
  <mat-icon
    class="icon seds-mx-2"
    fontSet="material-icons-outlined"
    [ngClass]="{ darkmode: colorMode === 'default-dark', lightmode: colorMode === 'default-light' }"
    >timer
  </mat-icon>
  <div *ngIf="colorMode === 'default-dark'">
    <p id="timer-text" class="seds-button-label darkmode seds-my-0" [attr.aria-label]="ariaLabel">
      Tempo de sessão {{ formatTime() }}
    </p>
    <div class="seds-progress">
      <div class="seds-progress-bar" role="progressbar" [style.width]="percentageBar + '%'"></div>
    </div>
  </div>
  <div *ngIf="colorMode === 'default-light'" [attr.aria-label]="ariaLabel">
    <p id="timer-text" class="seds-button-label lightmode seds-my-0 seds-font-regular">
      Tempo de sessão <span class="seds-format-timer">{{ formatTime() }}</span>
    </p>
  </div>
</div>
